/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetVisionStatusQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetVisionStatusQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    businessLine: Types.BusinessLine;
    vision: {
      __typename?: "Vision";
      canAccessVision: boolean;
      onboardingStatus: Types.OnboardingStatus;
      onboardingFailedMessage?: string | null;
      onboardingVideo: {
        __typename?: "Video";
        baseUrl: string;
        mediaPath: string;
        width: number;
        height: number;
        posterImageUrl?: string | null;
      };
    };
  } | null;
};

export const GetVisionStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getVisionStatus" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "businessLine" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "vision" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "canAccessVision" } },
                      { kind: "Field", name: { kind: "Name", value: "onboardingStatus" } },
                      { kind: "Field", name: { kind: "Name", value: "onboardingFailedMessage" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onboardingVideo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                            { kind: "Field", name: { kind: "Name", value: "width" } },
                            { kind: "Field", name: { kind: "Name", value: "height" } },
                            { kind: "Field", name: { kind: "Name", value: "posterImageUrl" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetVisionStatusQuery__
 *
 * To run a query within a React component, call `useGetVisionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisionStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVisionStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<GetVisionStatusQuery, GetVisionStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetVisionStatusQuery, GetVisionStatusQueryVariables>(
    GetVisionStatusDocument,
    options,
  );
}
export function useGetVisionStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetVisionStatusQuery, GetVisionStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetVisionStatusQuery, GetVisionStatusQueryVariables>(
    GetVisionStatusDocument,
    options,
  );
}
// @ts-ignore
export function useGetVisionStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetVisionStatusQuery,
    GetVisionStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetVisionStatusQuery, GetVisionStatusQueryVariables>;
export function useGetVisionStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetVisionStatusQuery, GetVisionStatusQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetVisionStatusQuery | undefined, GetVisionStatusQueryVariables>;
export function useGetVisionStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetVisionStatusQuery, GetVisionStatusQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetVisionStatusQuery, GetVisionStatusQueryVariables>(
    GetVisionStatusDocument,
    options,
  );
}
export type GetVisionStatusQueryHookResult = ReturnType<typeof useGetVisionStatusQuery>;
export type GetVisionStatusLazyQueryHookResult = ReturnType<typeof useGetVisionStatusLazyQuery>;
export type GetVisionStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetVisionStatusSuspenseQuery
>;
export type GetVisionStatusQueryResult = Apollo.QueryResult<
  GetVisionStatusQuery,
  GetVisionStatusQueryVariables
>;
